var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "w-full" },
        [
          _c(
            "DefaultContentLayout",
            [
              _c(
                "LoadingOverlay",
                {
                  attrs: {
                    hasData: _vm.hasData,
                    loading: _vm.loading,
                    spinnerCentered: "",
                  },
                },
                [
                  _c(
                    "div",
                    [
                      _c("ActionPanel", {
                        staticClass: "mb-4 mt-6",
                        attrs: {
                          total: _vm.paginationConfig.total,
                          pageName: `Total Pending Invites`,
                        },
                      }),
                      _c("p", [
                        _vm._v(
                          " Profiles are ready and active in ProveraCare but haven't been shared with the intended resource. You can choose to invite them for access or keep the profiles private for internal use only. "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c("ContractorCollectionFilters", {
                        attrs: {
                          currentUserId: _vm.currentUser.id,
                          hideManagersFilter: _vm.isManager,
                          parentInputClass: "pb-5",
                          filters: _vm.directoryFilters,
                          filterClass: "w-max-content",
                        },
                        on: {
                          filtersChanged: _vm.updateFilters,
                          resetFilters: _vm.resetFilters,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "table-container contractor-pending" },
                    [
                      _c(
                        "div",
                        { staticClass: "w-full flex justify-end mb-3" },
                        [
                          _c("UiButton", {
                            attrs: {
                              buttonText: "Send Invite",
                              variant: "outline",
                              buttonClasses: "px-2 pr-4 pl-4 customHeight40",
                              disabled: _vm.selectedContractor.length === 0,
                            },
                            on: {
                              click: function ($event) {
                                _vm.showModal = true
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.empty
                        ? _c("EmptyListPlaceholder", {
                            attrs: {
                              title: _vm.emptyListPlaceholder,
                              subtitle: "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "image",
                                  fn: function () {
                                    return [_c("EmptyListImageContractors")]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              143841379
                            ),
                          })
                        : _c("ContractorTable", {
                            attrs: {
                              data: _vm.contractors,
                              headers: _vm.headers,
                              selectedItems: _vm.selectedItems,
                              handleSelectAll: _vm.handleSelectAll,
                              areAllItemsSelected: _vm.areAllItemsSelected,
                              handleRowCheckboxChange:
                                _vm.handleRowCheckboxChange,
                              isInPopup: false,
                            },
                          }),
                      _c("CardPagination", {
                        attrs: { config: _vm.paginationConfig },
                        on: {
                          "update:config": function ($event) {
                            _vm.paginationConfig = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("ContractorInvite", {
        attrs: {
          showModal: _vm.showModal,
          headers: _vm.headers,
          data: _vm.selectedContractor,
          invitedByUserId: _vm.currentUser.id,
        },
        on: {
          close: function ($event) {
            _vm.showModal = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }